var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarrotDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00345 7.02409C6.17617 7.02409 6.34888 6.95592 6.46632 6.82641L11.8135 1.42082C11.9309 1.30493 12 1.15497 12 0.984552C12 0.630087 11.7306 0.357422 11.3713 0.357422C11.1986 0.357422 11.0397 0.425588 10.9223 0.534654L6.00345 5.49716L1.07772 0.534654C0.967185 0.425588 0.80829 0.357422 0.62867 0.357422C0.26943 0.357422 0 0.630087 0 0.984552C0 1.15497 0.0690846 1.30493 0.186529 1.42763L5.53368 6.82641C5.66494 6.95592 5.82383 7.02409 6.00345 7.02409Z",
    fill: "#BFBBCF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarrotDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/carrot-down.f2d7b60105d4944fe010994a7e63cf52.svg";